'use strict';

var index = require('../packages/aviary-core/dist/cjs/index.cjs');

var cjsExports = index.__require();

exports.cjsExports = cjsExports;
//# sourceMappingURL=index.cjs.map
